const STORAGE_KEY = 'guestAccess'
export const GUEST_ACCESS_EVENT = 'guest-access-granted'

function readStoredAccess() {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return null
    }
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function hasGuestAccess() {
  return !!readStoredAccess()
}

export function getGuestEmail() {
  const stored = readStoredAccess()
  return stored?.email || ''
}
